import { type ReactNode, useState } from "react";

/** The source must already have passed the public-media contract. */
export function PublicImage({
  src,
  alt,
  className,
  loading,
  retry = true
}: {
  src: string;
  alt: string;
  className: string;
  loading?: "lazy" | "eager";
  /** False when contained by a link; the item gallery provides the retry. */
  retry?: boolean;
}): ReactNode {
  const [failedSource, setFailedSource] = useState<string | null>(null);
  const [attempt, setAttempt] = useState(0);

  if (failedSource === src) {
    return (
      <div
        aria-label={`${alt}. Photograph could not load.`}
        className={`${className} media-unavailable`}
        role={retry ? "group" : "img"}
      >
        <span>Photo could not load</span>
        {retry ? <button className="btn btn--secondary" type="button" onClick={() => {
          setAttempt((current) => current + 1);
          setFailedSource(null);
        }}>Retry photo</button> : null}
      </div>
    );
  }

  return (
    <img
      alt={alt}
      className={className}
      decoding="async"
      loading={loading}
      key={`${src}:${String(attempt)}`}
      onError={() => { setFailedSource(src); }}
      src={src}
    />
  );
}
